export type FieldsErrors = Record<string, string[]>;

const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'string');

const getPropertyValue = (source: unknown, property: string): unknown => {
  if (source === null || typeof source !== 'object' || !(property in source)) {
    return undefined;
  }

  return (source as Record<string, unknown>)[property];
};

export const getFieldsErrors = (err: unknown): FieldsErrors => {
  const meta = getPropertyValue(err, 'meta');
  const fieldsErrors = getPropertyValue(meta, 'fieldsErrors');

  if (fieldsErrors === null || typeof fieldsErrors !== 'object') {
    return {};
  }

  return Object.entries(fieldsErrors).reduce<FieldsErrors>((acc, [field, messages]) => {
    if (isStringArray(messages)) {
      acc[field] = messages;
    } else if (typeof messages === 'string') {
      acc[field] = [messages];
    }

    return acc;
  }, {});
};
